module.exports = __webpack_public_path__ + "static/media/footer_4.f78f8ca7.png";